import { ModelPricing } from "../cost";

export const GOOGLE_PRICING: ModelPricing[] = [
  // === Gemini 3 (preview / API ids — verify on ai.google.dev) ===
  {
    provider: "Google AI",
    model: "gemini-3-pro-preview",
    inputPrice: 0.002, // $2/1M
    outputPrice: 0.012, // $12/1M
    contextWindow: 2_000_000,
    capabilities: ["text", "multimodal", "reasoning", "coding"],
    category: "multimodal",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-3-flash-preview",
    inputPrice: 0.00035,
    outputPrice: 0.0028,
    contextWindow: 1_000_000,
    capabilities: ["text", "multimodal", "reasoning"],
    category: "multimodal",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-3.1-pro",
    inputPrice: 0.002,
    outputPrice: 0.012,
    contextWindow: 2_000_000,
    capabilities: ["text", "multimodal", "reasoning", "coding"],
    category: "multimodal",
    isLatest: true,
  },
  // === Gemini 2.5 Models (Latest) ===
  {
    provider: "Google AI",
    model: "gemini-2.5-pro",
    inputPrice: 0.00125, // $1.25/1M tokens = $0.00125/1K tokens (<= 200k tokens)
    outputPrice: 0.01, // $10.0/1M tokens = $0.01/1K tokens (<= 200k tokens)
    contextWindow: 2000000,
    capabilities: ["text", "multimodal", "reasoning", "coding", "complex-problems", "thinking"],
    category: "multimodal",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash",
    inputPrice: 0.0003, // $0.3/1M tokens = $0.0003/1K tokens
    outputPrice: 0.0025, // $2.5/1M tokens = $0.0025/1K tokens
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal", "reasoning", "thinking", "live-api", "agents"],
    category: "multimodal",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash-lite-preview",
    inputPrice: 0.0001, // $0.1/1M tokens = $0.0001/1K tokens
    outputPrice: 0.0004, // $0.4/1M tokens = $0.0004/1K tokens
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal", "reasoning", "thinking", "high-throughput"],
    category: "multimodal",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash-lite",
    inputPrice: 0.0001, // $0.1/1M tokens = $0.0001/1K tokens
    outputPrice: 0.0004, // $0.4/1M tokens = $0.0004/1K tokens
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal", "reasoning", "thinking", "high-throughput"],
    category: "multimodal",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash-audio",
    inputPrice: 0.001, // $1.0/1M tokens = $0.001/1K tokens (audio input)
    outputPrice: 0.0025, // $2.5/1M tokens = $0.0025/1K tokens (text output)
    contextWindow: 1000000,
    capabilities: ["audio", "multimodal", "audio-input"],
    category: "audio",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash-lite-audio-preview",
    inputPrice: 0.0005, // $0.5/1M tokens = $0.0005/1K tokens (audio input)
    outputPrice: 0.0004, // $0.4/1M tokens = $0.0004/1K tokens (text output)
    contextWindow: 1000000,
    capabilities: ["audio", "multimodal", "audio-input", "high-throughput"],
    category: "audio",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash-native-audio",
    inputPrice: 0.0005, // $0.5/1M tokens = $0.0005/1K tokens (text)
    outputPrice: 0.002, // $2.0/1M tokens = $0.002/1K tokens (text)
    contextWindow: 1000000,
    capabilities: ["audio", "multimodal", "native-audio"],
    category: "audio",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash-native-audio-output",
    inputPrice: 0.003, // $3.0/1M tokens = $0.003/1K tokens (audio/video input)
    outputPrice: 0.012, // $12.0/1M tokens = $0.012/1K tokens (audio output)
    contextWindow: 1000000,
    capabilities: ["audio", "multimodal", "native-audio", "audio-output"],
    category: "audio",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-flash-preview-tts",
    inputPrice: 0.0005, // $0.5/1M tokens = $0.0005/1K tokens
    outputPrice: 0.01, // $10.0/1M tokens = $0.01/1K tokens (audio output)
    contextWindow: 1000000,
    capabilities: ["text-to-speech", "audio", "tts"],
    category: "audio",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemini-2.5-pro-preview-tts",
    inputPrice: 0.001, // $1.0/1M tokens = $0.001/1K tokens
    outputPrice: 0.02, // $20.0/1M tokens = $0.02/1K tokens (audio output)
    contextWindow: 1000000,
    capabilities: ["text-to-speech", "audio", "tts"],
    category: "audio",
    isLatest: true,
  },

  // === Gemini 2.0 Models ===
  {
    provider: "Google AI",
    model: "gemini-2.0-flash",
    inputPrice: 0.0001, // $0.1/1M tokens = $0.0001/1K tokens
    outputPrice: 0.0004, // $0.4/1M tokens = $0.0004/1K tokens
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal", "agents", "next-generation"],
    category: "multimodal",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-2.0-flash-lite",
    inputPrice: 0.000075, // $0.075/1M tokens = $0.000075/1K tokens
    outputPrice: 0.0003, // $0.3/1M tokens = $0.0003/1K tokens
    contextWindow: 1000000,
    capabilities: ["text", "multimodal", "cost-efficient", "low-latency"],
    category: "multimodal",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-2.0-flash-audio",
    inputPrice: 0.0007, // $0.7/1M tokens = $0.0007/1K tokens (audio input)
    outputPrice: 0.0004, // $0.4/1M tokens = $0.0004/1K tokens (text output)
    contextWindow: 1000000,
    capabilities: ["audio", "multimodal", "audio-input"],
    category: "audio",
    isLatest: false,
  },

  // === Gemini 1.5 Models ===
  {
    provider: "Google AI",
    model: "gemini-1.5-flash",
    inputPrice: 0.000075, // $0.075/1M tokens = $0.000075/1K tokens (<= 128k tokens)
    outputPrice: 0.0003, // $0.3/1M tokens = $0.0003/1K tokens (<= 128k tokens)
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal"],
    category: "multimodal",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-1.5-flash-large-context",
    inputPrice: 0.00015, // $0.15/1M tokens = $0.00015/1K tokens (> 128k tokens)
    outputPrice: 0.0006, // $0.6/1M tokens = $0.0006/1K tokens (> 128k tokens)
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal", "large-context"],
    category: "multimodal",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-1.5-flash-8b",
    inputPrice: 0.0000375, // $0.0375/1M tokens = $0.0000375/1K tokens (<= 128k tokens)
    outputPrice: 0.00015, // $0.15/1M tokens = $0.00015/1K tokens (<= 128k tokens)
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal", "efficient"],
    category: "multimodal",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-1.5-flash-8b-large-context",
    inputPrice: 0.000075, // $0.075/1M tokens = $0.000075/1K tokens (> 128k tokens)
    outputPrice: 0.0003, // $0.3/1M tokens = $0.0003/1K tokens (> 128k tokens)
    contextWindow: 1000000,
    capabilities: ["text", "image", "video", "multimodal", "efficient", "large-context"],
    category: "multimodal",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-1.5-pro",
    inputPrice: 0.00125, // $1.25/1M tokens = $0.00125/1K tokens (<= 128k tokens)
    outputPrice: 0.005, // $5.0/1M tokens = $0.005/1K tokens (<= 128k tokens)
    contextWindow: 2000000,
    capabilities: ["text", "code", "reasoning", "multimodal"],
    category: "text",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-1.5-pro-large-context",
    inputPrice: 0.0025, // $2.5/1M tokens = $0.0025/1K tokens (> 128k tokens)
    outputPrice: 0.01, // $10.0/1M tokens = $0.01/1K tokens (> 128k tokens)
    contextWindow: 2000000,
    capabilities: ["text", "code", "reasoning", "multimodal", "large-context"],
    category: "text",
    isLatest: false,
  },

  // === Gemma Models (Open Source) ===
  {
    provider: "Google AI",
    model: "gemma-3n",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "multimodal", "140-languages", "mobile-optimized"],
    category: "text",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemma-3",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 128000,
    capabilities: ["text", "open-source", "multimodal", "140-languages", "wide-variety-tasks"],
    category: "text",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "gemma-2",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "text-generation", "summarization", "extraction"],
    category: "text",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemma",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "text-generation", "summarization", "extraction", "lightweight"],
    category: "text",
    isLatest: false,
  },

  // === Specialized Gemma Models ===
  {
    provider: "Google AI",
    model: "shieldgemma-2",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "safety-evaluation", "instruction-tuned"],
    category: "safety",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "paligemma",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "vision-language", "siglip", "gemma"],
    category: "vision-language",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "codegemma",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "coding", "fill-in-middle", "code-generation", "mathematical-reasoning"],
    category: "coding",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "txgemma",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "therapeutic", "predictions", "classifications", "efficient-training"],
    category: "therapeutic",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "medgemma",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "medical", "medical-comprehension", "variants"],
    category: "medical",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "medsiglip",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "medical", "medical-images", "embedding-space"],
    category: "medical",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "t5gemma",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 8192,
    capabilities: ["text", "open-source", "encoder-decoder", "research", "lightweight", "powerful"],
    category: "research",
    isLatest: true,
  },

  // === Embeddings Models ===
  {
    provider: "Google AI",
    model: "text-embedding-004",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 2048,
    capabilities: ["embedding", "semantic-search", "classification", "clustering"],
    category: "embedding",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "multimodal-embeddings",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 2048,
    capabilities: ["embedding", "multimodal", "image-classification", "image-search"],
    category: "embedding",
    isLatest: true,
  },

  // === Imagen Models (Image Generation) ===
  {
    provider: "Google AI",
    model: "imagen-4-generation",
    inputPrice: 0.04, // Note: Price per request, not per 1K tokens
    outputPrice: 0.04, // Note: Price per request, not per 1K tokens
    contextWindow: 0,
    capabilities: ["image-generation", "text-to-image", "higher-quality"],
    category: "image",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "imagen-4-fast-generation",
    inputPrice: 0.04, // Note: Price per request, not per 1K tokens
    outputPrice: 0.04, // Note: Price per request, not per 1K tokens
    contextWindow: 0,
    capabilities: ["image-generation", "text-to-image", "higher-quality", "lower-latency"],
    category: "image",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "imagen-4-ultra-generation",
    inputPrice: 0.06, // Note: Price per request, not per 1K tokens
    outputPrice: 0.06, // Note: Price per request, not per 1K tokens
    contextWindow: 0,
    capabilities: ["image-generation", "text-to-image", "higher-quality", "better-prompt-adherence"],
    category: "image",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "imagen-3-generation",
    inputPrice: 0.03, // Note: Price per request, not per 1K tokens
    outputPrice: 0.03, // Note: Price per request, not per 1K tokens
    contextWindow: 0,
    capabilities: ["image-generation", "text-to-image"],
    category: "image",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "imagen-3-editing-customization",
    inputPrice: 0.03, // Note: Price per request, not per 1K tokens
    outputPrice: 0.03, // Note: Price per request, not per 1K tokens
    contextWindow: 0,
    capabilities: ["image-generation", "text-to-image", "image-editing", "customization", "mask-editing"],
    category: "image",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "imagen-3-fast-generation",
    inputPrice: 0.03, // Note: Price per request, not per 1K tokens
    outputPrice: 0.03, // Note: Price per request, not per 1K tokens
    contextWindow: 0,
    capabilities: ["image-generation", "text-to-image", "lower-latency"],
    category: "image",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "imagen-captioning-vqa",
    inputPrice: 0.03, // Note: Price per request, not per 1K tokens
    outputPrice: 0.03, // Note: Price per request, not per 1K tokens
    contextWindow: 0,
    capabilities: ["image-generation", "text-to-image", "image-editing", "mask-editing", "captioning", "vqa"],
    category: "image",
    isLatest: false,
  },

  // === Veo Models (Video Generation) ===
  {
    provider: "Google AI",
    model: "veo-2",
    inputPrice: 0.35, // Note: Price per second, not per 1K tokens
    outputPrice: 0.35, // Note: Price per second, not per 1K tokens
    contextWindow: 0,
    capabilities: ["video-generation", "text-to-video", "image-to-video", "higher-quality"],
    category: "video",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "veo-3",
    inputPrice: 0.35, // Note: Price per second, not per 1K tokens
    outputPrice: 0.35, // Note: Price per second, not per 1K tokens
    contextWindow: 0,
    capabilities: ["video-generation", "text-to-video", "image-to-video", "higher-quality"],
    category: "video",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "veo-3-fast",
    inputPrice: 0.35, // Note: Price per second, not per 1K tokens
    outputPrice: 0.35, // Note: Price per second, not per 1K tokens
    contextWindow: 0,
    capabilities: ["video-generation", "text-to-video", "image-to-video", "higher-quality", "lower-latency"],
    category: "video",
    isLatest: true,
  },

  // === Preview Models ===
  {
    provider: "Google AI",
    model: "virtual-try-on",
    inputPrice: 0.0, // Free tier only
    outputPrice: 0.0,
    contextWindow: 0,
    capabilities: ["image-generation", "virtual-try-on", "clothing"],
    category: "image",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "veo-3-preview",
    inputPrice: 0.35, // Note: Price per second, not per 1K tokens
    outputPrice: 0.35, // Note: Price per second, not per 1K tokens
    contextWindow: 0,
    capabilities: ["video-generation", "text-to-video", "image-to-video", "higher-quality", "preview"],
    category: "video",
    isLatest: true,
  },
  {
    provider: "Google AI",
    model: "veo-3-fast-preview",
    inputPrice: 0.35, // Note: Price per second, not per 1K tokens
    outputPrice: 0.35, // Note: Price per second, not per 1K tokens
    contextWindow: 0,
    capabilities: ["video-generation", "text-to-video", "image-to-video", "higher-quality", "lower-latency", "preview"],
    category: "video",
    isLatest: true,
  },

  // === Legacy Models for Backward Compatibility ===
  {
    provider: "Google AI",
    model: "gemini-1.0-pro",
    inputPrice: 0.001, // $1.00/1M tokens = $0.001/1K tokens
    outputPrice: 0.002, // $2.00/1M tokens = $0.002/1K tokens
    contextWindow: 32768,
    capabilities: ["text", "vision", "multimodal"],
    category: "text",
    isLatest: false,
  },
  {
    provider: "Google AI",
    model: "gemini-1.0-pro-vision",
    inputPrice: 0.001, // $1.00/1M tokens = $0.001/1K tokens
    outputPrice: 0.002, // $2.00/1M tokens = $0.002/1K tokens
    contextWindow: 32768,
    capabilities: ["text", "vision", "multimodal"],
    category: "text",
    isLatest: false,
  },
];
